import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getGoogleMapsHabilitado } from "../../../utils/variablesLocales";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Form, Segment, Divider, Input, List } from "semantic-ui-react";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import PlaceIcon from "@mui/icons-material/Place";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from "@mui/icons-material/Cancel";
import { ENTORNO } from "../../../utils/constantes";
import {
  calcular_trayecto,
  cancelar,
  nuevo_viaje,
  si,
  vas_a_confirmar_el_viaje,
  viaje_registrado_con_exito,
  tienes_un_viaje_en_curso,
  en_cuanto_finalice_el_mismo_podras_solicitar_uno_nuevo,
  resumen_del_viaje,
  destino,
  partida,
  trayecto,
  resumen,
  confirmar,
  metodo_de_pago,
  falta_agregar_metodo_de_pago_valido,
  pago,
  selecciona_punto_de_partida,
  selecciona_punto_destino,
  para_continuar_debes_activar_el_gps,
  punto_de_partida,
  punto_destino,
  buscar_calle,
  tu_ubicacion,
} from "../../../utils/traductor";

export function NuevoViaje2() {
  const navigate = useNavigate();

  const navigateToInicio = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  useEffect(() => {
    const initMap = () => {
      const map = new window.google.maps.Map(document.getElementById("map"), {
        center: { lat: 40.712776, lng: -74.005974 }, // juan, por defecto acá te lleva a New York. Cambialo o ya te digo como...
        zoom: 12,
        disableDefaultUI: true,
      });
    };

    const loadMap = () => {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAMqRtQO0710z-o3NJGNXZtCpfUBObWJe4`;
      script.async = true;
      script.defer = true;
      script.onload = initMap;
      document.body.appendChild(script);
    };

    loadMap();
  }, []);

  return (
    <div>
      <AppBar style={{ background: "#DC030E" }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            onClick={navigateToInicio}
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 0 }}>
            {nuevo_viaje}
          </Typography>
        </Toolbar>
      </AppBar>

      <div
        id="divPartidaDestino"
        style={{
          position: "absolute",
          marginTop: "10px",
          backgroundColor: "white",
          left: "0",
          right: "0",
          margin: "15px",
          marginLeft: "15px",
          padding: "0px",
          borderRadius: "10px",
          zIndex: "30",
        }}
      >
        Partida... Destino
      </div>

      <div
        id="map"
        style={{ width: "100%", height: "95vh", marginTop: "35px" }}
      ></div>

      <div
        id="divResumenViaje"
        name="divResumenViaje"
        style={{
          textAlign: "center",
          position: "absolute",
          backgroundColor: "white",
          left: "0",
          right: "0",
          bottom: "0",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          paddingTop: "10px",
          zIndex: "20",
        }}
      >
        {resumen_del_viaje}
        <Divider></Divider>
        {/* <b>PARTIDA</b>
        <br></br>
        Lat: {PartidaLatitud}
        <br></br>
        Lon: {PartidaLongitud}
        <br></br>
        Dirección: {PartidaDireccion}
        <br></br>
        <br></br>
        <b>DESTINO</b>
        <br></br>
        Lat: {DestinoLatitud}
        <br></br>
        Lon: {DestinoLongitud}
        <br></br>
        Dirección: {DestinoDireccion}
        <br></br>
        <br></br>
        Kms: {Kms}
        <br></br>
        Min: {Min}
        <br></br>
        Precio: {Precio} */}
      </div>
    </div>
  );
}
